import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { LicenseExpiryNotice } from '@parkingless/interface';
import { url } from '../../config/app.constants';

/**
 * The strip under the toolbar while the licence covering what is on screen is in its last
 * days (`licenseExpiryNotice`, the same rule and words as the garage app).
 *
 * It cannot be dismissed: the day after, the console closes on whoever ignored it. Its
 * holder is offered the renewal; anyone else is told to warn them, because they cannot
 * renew a licence that is not theirs.
 */
@Component({
  selector: 'app-license-banner',
  standalone: true,
  imports: [RouterLink, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (notice(); as current) {
      <div class="license-banner" role="status" data-testid="license-banner">
        <mat-icon class="license-banner-icon">schedule</mat-icon>
        <span class="license-banner-text">{{ current.text }}</span>
        @if (current.canRenew && !hideAction()) {
          <a class="license-banner-action" [routerLink]="renewPath">Rinnova</a>
        }
      </div>
    }
  `,
  styleUrl: './license-banner.component.scss',
})
export class LicenseBannerComponent {
  readonly notice = input<LicenseExpiryNotice | null>(null);
  /** On the purchase page itself the link would lead where the reader already is. */
  readonly hideAction = input(false);

  protected readonly renewPath = `/${url.buyLicense.path}`;
}
